// Feature 46570 - DTOs de carga masiva de traspasos (lado Angular).

/** Una fila del layout (detalle). */
export class TransferRequestBulkRowDto {
    StoreOriginCode: string;
    StoreDestinyCode: string;
    Sector: string;
    StyleVariety: string;
    SizeName: string;
    Season: string;
    Comment: string;
    Quantity: number;
}

/** Payload de carga: cabecera + filas. Coincide con TransferRequestBulkUploadDto del backend. */
export class TransferRequestBulkUploadDto {
    language: number;
    week: number;
    year: number;
    reference: string;
    organizationId: string;
    startDate: Date;
    endDate: Date;
    data: TransferRequestBulkRowDto[];
}

/** Resumen de un job de carga (para la lista "Mis cargas"). */
export class TransferRequestBulkJobDto {
    operationGuid: string;
    userEmail: string;
    organizationId: string;
    status: string;         // Queued / Processing / Done / CompletedWithErrors / Failed
    totalRows: number;
    processedCount: number;
    successCount: number;
    failedCount: number;
    queuedDate: Date;
    startedDate: Date;
    finishedDate: Date;
    message: string;
}


